<template>
  <div>

    <div class="drugstores-suppliers-stage">

      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>

      <div v-if="bindModeOn === true" class="row">
        <div class="form-group">
          <label for="showOnlyUnBound" style="margin-right:4px!important">Pokaż tylko niepowiązane</label>
          <input type="checkbox" id="showOnlyUnBound" v-model="showOnlyUnBound"/>
        </div>
      </div>
      <div class="drugstores-suppliers-table-container">
        <div>
          <CommonTable2
              :table="tableData"
              :rowIdentifier="rowIdentifierKey"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getRawDrugstoresSuppliersDataTotal"
              :totalPages="commonModule.getRawDrugstoresSuppliersPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="true"
              :showRowActions="false"
              :multiselect="true"
          />
        </div>


      </div>


    </div>


  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";

import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import {suppliersHelperMethods} from "./helper/suppliersHelperMethods";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export default {
  name: "BoundLocalSuppliersList",
  props: {
    boundWithCentralGuid: {
      type: String,
      required: true,
      default: () => null
    },
    bindModeOn: {
      type: Boolean,
      default: () => false
    }

  },
  emits: ["onSelect", "onUnbind", "onBind"],
  components: {
    SearchBar2,
    CommonTable2
  },
  data() {
    return {
      rowIdentifierKey: "data_row_id",
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "NAZWA_DOSTAWCY",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      localSuppliersRows: [],
      availableHeaders: [],
      tableMassActions: [
        {
          text: "Usuń powiązania",
          icon: "fas fa-link-slash",
          action: "remove-central-supplier-binding",
          class: "btn btn-warning table-actions-button edit-button",
          enabled: true,
        }
      ],
      rowActions: [],
      suppliersVisibleHeaders: ["id_kamsoft_dost", "data_row_id", "id_apteki", "nazwa_dostawcy", "nip", "nazwa_kartoteki_centralnej_dostawcy"],
      drugstoresLocalSuppliersVisibleHeadersTitlesMap: {
        "id_kamsoft_dost": "IdKamsoft",
        "data_row_id": "IdLocal",
        "id_apteki": "Apteka",
        "nazwa_dostawcy": "Nazwa dostawcy",
        "nip": "NIP",
        "nazwa_kartoteki_centralnej_dostawcy": "Centralny dostawca"

      },
      fieldsAvailableForSearch: [],
      showOnlyUnBound: false,
      refreshTable: true, //added key to force re-rendering
      localIdsSelected: []

    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    }
  },
  methods: {

    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshLocalSuppliersData();
    },
    runAction(event) {
      log.log(event);
    },

    refreshLocalSuppliersData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o dostawcach lokalnych w aptekach.");
      return this.commonModule.httpGetRawDrugstoresSuppliersHeaders().then(() => {
        this.refreshTable = false;

        var centralGuidToFilter = this.bindModeOn === true ? null : this.boundWithCentralGuid;
        log.log("centralGuidToFilter: " + centralGuidToFilter);

        return suppliersHelperMethods.refreshLocalSuppliersList(this.rowActions, this.drugstoresLocalSuppliersVisibleHeadersTitlesMap, this.suppliersVisibleHeaders, this.currentPage, this.sortingKey,
            this.sortingDirection, this.searchRequest, this.showOnlyUnBound, centralGuidToFilter).then((responsePayload) => {
          this.availableHeaders = responsePayload.availableHeaders;
          this.localSupplierHeaders = responsePayload.localSupplierHeaders;
          this.localSuppliersRows = responsePayload.localSuppliersRows;
          var localSuppliersRowsFiltered = this.localSuppliersRows
          if (this.bindModeOn === true) {
            localSuppliersRowsFiltered = [];
            // hide local supplier already bound with current central supplier
            log.log("this.boundWithCentralGuid:")
            log.log(this.boundWithCentralGuid)
            log.log(this.localSuppliersRows)
            log.log("-----------------")
            for (let i = 0; i < this.localSuppliersRows.length; i++) {
              if (this.localSuppliersRows[i]['guid_kartoteki_centralnej_dostawcy'] === this.boundWithCentralGuid) {
                // omit this item // TODO: add method in backend which will include bindModeOn an omit items that are already bound to current central supplier
              } else {
                localSuppliersRowsFiltered.push(this.localSuppliersRows[i]);
              }
            }
          }

          this.tableData = {
            headers: this.localSupplierHeaders,
            data: localSuppliersRowsFiltered,
            massActions: this.tableMassActions
          }

        }).then(() => {
          this.refreshTable = true;
          suppliersHelperMethods.refreshFieldsAvailableForSearch(this.availableHeaders, this.drugstoresLocalSuppliersVisibleHeadersTitlesMap).then((responsePayload) => {
            this.fieldsAvailableForSearch = responsePayload.fieldsAvailableForSearch;
          });
        });
      });
    },

    runMassAction(event) {
      log.log(event);
      if (event.action.action === "remove-central-supplier-binding") {
        this.$emit("onUnbind", event.items);
        suppliersHelperMethods.unBindCentralSupplier(event.items, this.rowIdentifierKey, this.localSuppliersRows).then((responsePayload) => {
          if (responsePayload.isConfirmed) {
            this.refreshLocalSuppliersData();
          }
        });
      } else if (event.action.action === "bind-central-supplier") {
        this.$emit("onBind", this.localIdsSelected);
        suppliersHelperMethods.bindWithSupplier(this.localIdsSelected, this.rowIdentifierKey, null, this.boundWithCentralGuid)
      }
    },

    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshLocalSuppliersData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      this.localIdsSelected = event.items
      this.$emit("onSelect", event.items);
    },


  },
  watch: {
    currentPage: {
      handler() {
        this.refreshLocalSuppliersData();
      },
      deep: true,
    },

    showOnlyUnBound: {
      handler() {
        this.refreshLocalSuppliersData();
      },
      deep: true,
    },


  },
  mounted() {
    if (this.bindModeOn === true) {
      this.tableMassActions.push({
        text: "Powiąż z obecnym dostawcą centralnym",
        icon: "fas fa-link",
        action: "bind-central-supplier",
        class: "btn btn-success table-actions-button edit-button",
        enabled: true,
      });
    }
  },
  created() {
    this.refreshLocalSuppliersData();
  },
};
</script>

<style scoped>
.drugstores-suppliers-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.drugstores-suppliers-table-container {
}

.drugstores-suppliers-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.supplier-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}


</style>
